import { gql } from "@apollo/client";
import { VIDEO_FIELDS } from "../fragments";

export const CREATE_VIDEO = gql`
  ${VIDEO_FIELDS}
  mutation VideoCreate($input: CreateVideoInput!) {
    videoCreate(input: $input) {
      ...VideoFields
    }
  }
`;

export const DELETE_VIDEO = gql`
  mutation VideoDelete($videoId: UUID!) {
    videoDelete(videoId: $videoId) {
      id
    }
  }
`;
